export default class ScrollTo {

  constructor() {
    const self = this;
    this.scrollToButtons = document.querySelectorAll('.scroll-to-btn')

    if (this.scrollToButtons.length) {
      for (const button of this.scrollToButtons) {
        button.addEventListener('click', (evt) => {
          evt.preventDefault()
          const elementY = document.querySelector(evt.target.hash)
          if (elementY) {
            self.doScrolling(elementY.getBoundingClientRect().top, 100)
          }
        })
      }
    }
  }

  doScrolling(elementY, duration) {
    const startingY = window.pageYOffset;
    const diff = elementY - startingY;
    let start;

    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp;
      const time = timestamp - start;
      const percent = Math.min(time / duration, 1);

      window.scrollTo(0, startingY + diff * percent);

      if (time < duration) {
        window.requestAnimationFrame(step);
      }
    })
  }
}
